import { COMPANIES_SETTING_URLS, TCompanySettingParams, getCompaniesSettingUrls } from 'api/config';
import $api from 'api/http';

export default class CompaniesSettingsService {
    static async kpis(params: TCompanySettingParams) {
        return $api.get(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.kpis, ...params }));
    }
    static async kpisUpdate(params: TCompanySettingParams) {
        return $api.post(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.kpisUpdate, ...params }), params);
    }
    static async integrationsApis(params: TCompanySettingParams) {
        return $api.get(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.apis, ...params }));
    }
    static async integrationsApisUpdate(params: TCompanySettingParams & { id: string; key: string }) {
        return $api.post(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.apisUpdate, ...params }), {
            id: params.id,
            key: params.key,
        });
    }
    static async callouts(params: TCompanySettingParams) {
        return $api.get(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.callouts, ...params }));
    }
    static async calloutsUpdate(params: TCompanySettingParams & { callouts: Array<{ metric: string; key: string }> }) {
        return $api.post(getCompaniesSettingUrls({ reqName: COMPANIES_SETTING_URLS.calloutsUpdate, ...params }), {
            callouts: params.callouts,
        });
    }
}
